<template>
  <div class="rounded-sm border">
    <div class="border-b p-4 font-semibold text-headline">{{ title }}</div>
    <div class="grid grid-cols-3 divide-x">
      <div class="space-y-2 p-4">
        <div>{{ $t("DEALS.LEXIS_NEXIS.BUSINESS_CREDIT.OPEN_ACCOUNTS") }}</div>
        <div class="text-lg font-semibold text-headline">
          {{ tradeSummary.OpenAccountsCount }}
        </div>
      </div>
      <div class="space-y-2 p-4">
        <div>
          {{ $t("DEALS.LEXIS_NEXIS.BUSINESS_CREDIT.CHARGE_OFF_RECORDED") }}
        </div>
        <div class="text-lg font-semibold text-headline">
          {{ tradeSummary.ChargeOffRecorded }}
        </div>
      </div>
      <div class="space-y-2 p-4">
        <div>
          {{ $t("DEALS.LEXIS_NEXIS.BUSINESS_CREDIT.ACCOUNTS_WITH_GUARANTOR") }}
        </div>
        <div class="text-lg font-semibold text-headline">
          {{ tradeSummary.AccountsWithGuarantor }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TradeSummary } from "@/models/commercialData/lexisnexis/LexisNexisSmallBusinessBlendedCreditScore";

defineProps<{
  tradeSummary: TradeSummary;
  title: string;
}>();
</script>
